"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const POOL_ADDRESSES = {
    42161: {
        rsETH: '0xC9e93E3cff0F8AeD98700563532019Dd21f1dBB8',
        new_rsETH: '0xd92E09e6281A2cFB28B2D2986eE900661Bfa3Df9',
    },
    1: {
        rsETH: '0xe1B4d34E8754600962Cd944B535180Bd758E6c2e',
    },
};
exports.default = POOL_ADDRESSES;
//# sourceMappingURL=addresses.js.map